import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/api/errors'

/**
 * Shared QueryClient for the app.
 *
 * Retry policy:
 *   - Never retry 4xx (the request is wrong; retrying won't help).
 *   - Never retry on AbortError (cancellation is intentional).
 *   - Retry network / 5xx up to 2 times with exponential backoff.
 *
 * Mutations don't retry by default — they may have side effects.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000, // 30s — most lists are fine to be slightly stale
        gcTime: 5 * 60 * 1000, // 5min — keep recently used queries in memory
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError) {
            if (error.status >= 400 && error.status < 500) return false
          }
          return failureCount < 2
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        retry: false,
      },
    },
  })
}
